class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.querySelector('summary');

    // Open on hover for desktop
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Handle click on parent summary
    if (this.summary) {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }

    // Handle nested submenus (2nd level dropdowns)
    this.subMenus = this.querySelectorAll('details[id^="Details-HeaderSubMenu-"]');
    this.subMenus.forEach((subMenu) => {
      const subSummary = subMenu.querySelector('summary');
      subMenu.addEventListener('mouseenter', () => subMenu.setAttribute('open', ''));
      subMenu.addEventListener('mouseleave', () => subMenu.removeAttribute('open'));
      if (subSummary) {
        subSummary.addEventListener('click', (event) => {
          const url = subSummary.dataset.href;
          if (url && url !== '#' && url.trim() !== '') {
            event.preventDefault();
            if (event.ctrlKey || event.metaKey || event.button === 1) {
              window.open(url, '_blank');
            } else {
              window.location.href = url;
            }
          }
        });
      }
    });
  }

  onMouseEnter() {
    // Close other open header-menus
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'true');
    }
    this.onToggle();
  }

  onMouseLeave() {
    this.close();
  }

  onSummaryClick(event) {
    const url = this.summary ? this.summary.dataset.href : null;
    if (url && url !== '#' && url.trim() !== '') {
      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
